import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-mail-inprocess-delegate.component.ajs';

@Directive({
  selector: 'cng-agent-booking-mail-inprocess-delegate-upgrade',
})
export class AgentBookingMailInprocessDelegateUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-mail-inprocess-delegate',
  template:
    '<cng-agent-booking-mail-inprocess-delegate-upgrade [responseId]="responseId$ | async"></cng-agent-booking-mail-inprocess-delegate-upgrade>',
})
export class AgentBookingMailInprocessDelegateComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
